// extracted by mini-css-extract-plugin
var _1 = "RequestProfileTabEmailsMoveToTabModalFields-modulefield__dg2f9 FieldStackedLabel-moduleFieldStackedLabel__iylwV Field-moduleField__kZH_K";
export { _1 as "field" }
